import {
	ADMIN_DASHBOARD_SEARCH_SUBMIT,
	ADMIN_DASHBOARD_SEARCH_SUCCESS,
	ADMIN_DASHBOARD_SEARCH_ERROR,
	ADMIN_DASHBOARD_CHANGE_SUBMIT,
	ADMIN_DASHBOARD_CHANGE_SUCCESS,
	ADMIN_DASHBOARD_CHANGE_ERROR,
	ADMIN_DASHBOARD_INSERT_SUBMIT,
	ADMIN_DASHBOARD_INSERT_SUCCESS,
	ADMIN_DASHBOARD_INSERT_ERROR,
	GET_DASHBOARD_OPTIONS,
	GET_DASHBOARD_OPTIONS_SUCCESS,
	GET_DASHBOARD_OPTIONS_ERROR,
	GET_ADMIN_CSV,
	GET_ADMIN_CSV_SUCCESS,
	GET_ADMIN_CSV_ERROR,
	RUN_CALCULATIONS,
	RUN_CALCULATIONS_SUCCESS,
	RUN_CALCULATIONS_ERROR,
	GET_TEAM_HEALTH_SCORE_NFL,
	GET_TEAM_HEALTH_SCORE_NFL_SUCCESS,
	GET_TEAM_HEALTH_SCORE_NFL_ERROR,
	ADMIN_GET_DFS_PICKS,
	ADMIN_GET_DFS_PICKS_SUCCESS,
	ADMIN_GET_DFS_PICKS_ERROR,
	ADMIN_SAVE_DFS_PICK,
	ADMIN_SAVE_DFS_PICK_SUCCESS,
	ADMIN_SAVE_DFS_PICK_ERROR,
	ADMIN_DELETE_DFS_PICK,
	ADMIN_DELETE_DFS_PICK_SUCCESS,
	ADMIN_DELETE_DFS_PICK_ERROR,
	ADMIN_SEARCH_DFS_PLAYERS,
	ADMIN_SEARCH_DFS_PLAYERS_SUCCESS,
	ADMIN_SEARCH_DFS_PLAYERS_ERROR,
	ADMIN_FILTER_DFS_PLAYERS,
	ADMIN_CLEAR_DFS_SEARCH
} from './constants';

const filterRoster = (roster, query) => {
	const q = (query || '').trim().toLowerCase();
	const matched = q
		? roster.filter((p) => (p.name || '').toLowerCase().includes(q))
		: roster;
	return matched.slice(0, 25);
};

const initialState = {
	isLoaded: false,
	isLoading: false
	// data: {}
};

const userInitialState = {
	payload: null
};

export const adminDashboardCSV = (state = initialState, { type, payload = '' }) => {
	switch (type) {
		case GET_ADMIN_CSV:
			return {
				...state,
				isLoading: true
			};
		case GET_ADMIN_CSV_SUCCESS:
			return {
				isLoading: false,
				data: payload
			};
		case GET_ADMIN_CSV_ERROR:
			return {
				...state,
				isLoading: false,
				error: 'There was an error retrieving the files'
			};
		default:
			return state;
	}
};
export const adminTeamHealthScoreNFL = (state = initialState, { type, payload = '' }) => {
	switch (type) {
		case GET_TEAM_HEALTH_SCORE_NFL:
			return {
				...state,
				isLoading: true
			};
		case GET_TEAM_HEALTH_SCORE_NFL_SUCCESS:
			return {
				...state,
				success: true,
				isLoading: false,
				message: payload.message,
				error: false,
				records: payload?.records || [],
				total_records: payload?.total_records || 0
			};
		case GET_TEAM_HEALTH_SCORE_NFL_ERROR:
			return {
				...state,
				success: false,
				isLoading: false,
				message: payload.message,
				error: true
			};
		default:
			return state;
	}
};

export const adminDashboardOptions = (state = initialState, { type, payload = '' }) => {
	switch (type) {
		case GET_DASHBOARD_OPTIONS:
			return {
				...state,
				isLoading: true
			};
		case GET_DASHBOARD_OPTIONS_SUCCESS:
			return {
				isLoading: false,

				data: payload
			};
		case GET_DASHBOARD_OPTIONS_ERROR:
			return {
				...state,
				isLoading: false,
				error: 'There was an error retrieving the admin dashboard options'
			};
		default:
			return state;
	}
};

export const adminDashboardSearch = (state = initialState, { type, payload = '' }) => {
	switch (type) {
		case ADMIN_DASHBOARD_SEARCH_SUBMIT:
		case ADMIN_DASHBOARD_CHANGE_SUBMIT:
		case ADMIN_DASHBOARD_INSERT_SUBMIT:
			return {
				...state,
				isLoading: true
			};
		case ADMIN_DASHBOARD_SEARCH_SUCCESS:
			return {
				...state,
				isLoading: false,
				info: payload.info,
				details: payload.details,
				ircTable: payload.ircTable,
				hpfTable: payload.hpfTable,
				rawCrawler: payload.rawCrawler,
				convertedCrawler: payload.convertedCrawler,
				teamTable: payload.teamTable,
				schedulesTable: payload.schedulesTable,
				heatmapTable: payload.heatmapTable,
				message: payload.message,
				error: false
			};
		case ADMIN_DASHBOARD_CHANGE_SUCCESS:
			return {
				...state,
				success: true,
				isLoading: false,

				message: payload.message,
				error: false
			};
		case ADMIN_DASHBOARD_INSERT_SUCCESS:
			return {
				...state,
				success: true,
				isLoading: false,

				message: payload.message,
				error: false
			};
		case ADMIN_DASHBOARD_SEARCH_ERROR:
		case ADMIN_DASHBOARD_CHANGE_ERROR:
		case ADMIN_DASHBOARD_INSERT_ERROR:
			return {
				...state,
				success: false,
				isLoading: false,
				message: payload.message,
				error: true
			};
		default:
			return state;
	}
};

const dfsPicksInitialState = {
	isLoading: false,
	isLoaded: false,
	saving: false,
	picks: {}, // { [sportsID]: pick }
	search: {
		isLoading: false,
		sportsID: null,
		league: '',
		query: '',
		results: []
	},
	rosterBySport: {}, // { [`${sportsID}|${league}`]: normalizedRoster[] }
	error: null,
	message: null
};

export const adminDfsPicks = (state = dfsPicksInitialState, { type, payload = {} }) => {
	switch (type) {
		case ADMIN_GET_DFS_PICKS:
			return { ...state, isLoading: true, error: null };
		case ADMIN_GET_DFS_PICKS_SUCCESS:
			return { ...state, isLoading: false, isLoaded: true, picks: payload.picks || {} };
		case ADMIN_GET_DFS_PICKS_ERROR:
			return { ...state, isLoading: false, error: payload.message || 'Failed to load DFS picks' };

		case ADMIN_SAVE_DFS_PICK:
			return { ...state, saving: true, error: null, message: null };
		case ADMIN_SAVE_DFS_PICK_SUCCESS: {
			const pick = payload.pick;
			const sportsID = pick?.sportsID;
			return {
				...state,
				saving: false,
				message: payload.message || 'Pick saved',
				picks: sportsID ? { ...state.picks, [ sportsID ]: pick } : state.picks
			};
		}
		case ADMIN_SAVE_DFS_PICK_ERROR:
			return { ...state, saving: false, error: payload.message || 'Failed to save pick' };

		case ADMIN_DELETE_DFS_PICK:
			return { ...state, saving: true, error: null };
		case ADMIN_DELETE_DFS_PICK_SUCCESS: {
			const next = { ...state.picks };
			delete next[ payload.sportsID ];
			return { ...state, saving: false, picks: next, message: 'Pick removed' };
		}
		case ADMIN_DELETE_DFS_PICK_ERROR:
			return { ...state, saving: false, error: payload.message || 'Failed to delete pick' };

		case ADMIN_SEARCH_DFS_PLAYERS: {
			const cacheKey = `${payload.sportsID}|${payload.league || ''}`;
			const cached = state.rosterBySport[cacheKey];
			return {
				...state,
				search: {
					...state.search,
					isLoading: !cached,
					sportsID: payload.sportsID,
					league: payload.league || '',
					query: payload.query || '',
					results: cached ? filterRoster(cached, payload.query) : []
				}
			};
		}
		case ADMIN_SEARCH_DFS_PLAYERS_SUCCESS: {
			const roster = payload.roster || [];
			const cacheKey = `${payload.sportsID}|${payload.league || ''}`;
			return {
				...state,
				rosterBySport: { ...state.rosterBySport, [cacheKey]: roster },
				search: {
					...state.search,
					isLoading: false,
					sportsID: payload.sportsID,
					league: payload.league || '',
					query: payload.query || state.search.query,
					results: filterRoster(roster, payload.query ?? state.search.query)
				}
			};
		}
		case ADMIN_SEARCH_DFS_PLAYERS_ERROR:
			return { ...state, search: { ...state.search, isLoading: false, results: [] }, error: payload.message };
		case ADMIN_FILTER_DFS_PLAYERS: {
			const cacheKey = `${state.search.sportsID}|${state.search.league || ''}`;
			const roster = state.rosterBySport[cacheKey] || [];
			return {
				...state,
				search: { ...state.search, query: payload.query || '', results: filterRoster(roster, payload.query) }
			};
		}
		case ADMIN_CLEAR_DFS_SEARCH:
			return { ...state, search: { isLoading: false, sportsID: null, league: '', query: '', results: [] } };

		default:
			return state;
	}
};

export const adminDashboardCalculations = (state = initialState, { type, payload = '' }) => {
	switch (type) {
		case RUN_CALCULATIONS:
			return {
				...state,
				isLoading: true
			};
		case RUN_CALCULATIONS_SUCCESS:
			return {
				...state,
				success: true,
				isLoading: false,
				message: payload.message,
				error: false
			};
		case RUN_CALCULATIONS_ERROR:
			return {
				...state,
				success: false,
				isLoading: false,
				message: payload.message,
				error: true
			};
		case ADMIN_DASHBOARD_SEARCH_SUBMIT:
		case ADMIN_DASHBOARD_CHANGE_SUBMIT:
		case ADMIN_DASHBOARD_INSERT_SUBMIT:
			return {
				isLoading: false,
				message: payload.message
			};
		default:
			return state;
	}
};
